import { 
    cloneObject,
    textDateLocale,
    textFormat
}                               from "../../_common";
import {
    AAutoCompleteCriteria
}                               from "../../_common/models/autocomplete";

export class TheatreAutoCompleteCriteria 
                extends AAutoCompleteCriteria {
    public CircuitID: number;

    public get criteriaKey(): string {
        let key = "";
        if (this.CircuitID != undefined) {
            key = this.CircuitID.toString();
        }

        return key;
    }
}
export class TheatreSubAutoCompleteCriteria 
                extends AAutoCompleteCriteria {
    public TheatreID: number;

    public get criteriaKey(): string {
        let key = "";
        if (this.TheatreID != undefined) {
            key = this.TheatreID.toString();
        }

        return key;
    }
}
export class TheatreSystemAutoCompleteCriteria 
                extends AAutoCompleteCriteria {
    public TheatreID: number;
    public TheatreSubID: number;

    public get criteriaKey(): string {
        let key = "";
        if (this.TheatreID != undefined) {
            key = this.TheatreID.toString();

            if (this.TheatreSubID != undefined) {
                key = ":" + this.TheatreSubID.toString();
            }
        }

        return key;
    }
}
export class FreeTicketCapTypeAutoCompleteCriteria 
                extends AAutoCompleteCriteria {
    public MovieID: number;
    public CircuitID: number;
    public TheatreID: number;

    public get criteriaKey(): string {
        let key = "";
        if (this.MovieID != undefined) {
            key = this.MovieID.toString();

            if (this.CircuitID != undefined) {
                key += "::" + this.CircuitID.toString();
            }
            if (this.TheatreID != undefined) {
                key += "::" + this.TheatreID.toString();
            }
        }

        return key;
    }
}
export class TicketTypeAutoCompleteCriteria 
                extends AAutoCompleteCriteria {
    public MovieID: number;
    public CircuitID: number;
    public TheatreID: number;

    public get criteriaKey(): string {
        let key = "";
        if (this.MovieID != undefined) {
            key = this.MovieID.toString();

            if (this.CircuitID != undefined) {
                key += "::" + this.CircuitID.toString();
            }
            if (this.TheatreID != undefined) {
                key += "::" + this.TheatreID.toString();
            }
        }

        return key;
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_custom/models/autocomplete.criteria.ts